define('community-posts-add',['controller', 'community-editor', 'socket', 'tooltip-notifier'],
function(controller, editor, socket, tooltipNotifier) {
	var thread_id;
	var form_submitted = false;
	
	//===================== load ============================
	
	function onLoadClick() {
		var button = $(this);
		var last_post_id = $('#forum-thread-posts .single-post-basic').first().data('post-id');

		$.ajax({
			url: '/forum/-/' + thread_id + '/load',
			type: 'POST',
			data: {'posts/add': true, last_post_id: last_post_id},
			dataType: 'json'
		}).done(function(data) {
			$('#forum-thread-posts').prepend(data.html);
			$('#load').html('');
			$('#load').data('new-posts', 0);
		}).fail(function(xhr) {
			tooltipNotifier.showError(button, 'Fehler beim Nachladen', xhr);
		});
	}
	
	//==================== socket events ====================
	
	function onThreadAdd(e) {
		if($('.single-post-basic[data-post-id=' + e.post_id + ']').length > 0) // post already on page
			return;
		
		if(form_submitted) // user already submitted the add-form so wen don't to show him his own post
			return;
		
		var prev_new_posts_count = $('#load').data('new-posts');
		var new_posts_count = prev_new_posts_count + 1;
		var button = $('<button>')
						.addClass('button')
						.addClass('secondary-button')
						.addClass('load-button')
						.click(onLoadClick);
		
		$('#load').data('new-posts', new_posts_count);
		
		if(new_posts_count == 1) // first new post
			button.html(new_posts_count + ' neuen Beitrag anzeigen');
		else
			button.html(new_posts_count + ' neue Beiträge anzeigen');
		
		$('#load').html(button);
	}
	
	controller.on('community/posts/add', function() {
		thread_id = $('#forum-thread-posts').data('thread-id');
		
		$('.thread-answer-form').submit(function() {
			form_submitted = true;
		});

		socket.on('thread-' + thread_id + '-add', onThreadAdd);
		
		editor.initMCE('#thread-text-input');
	}, function() {
		socket.off('thread-' + thread_id + '-add', onThreadAdd);
		editor.destroy();
	});
});

